const labels: Record<string, string> = {
  scheduled: 'Agendada',
  completed: 'Concluída',
  deleted: 'Cancelada',
  no_show: 'Faltou',
};

export function getGuideStatusLabel(status: string): string {
  return labels[status] || 'Autorizada';
}
